//PrimeReact
import { Dialog } from "primereact/dialog"
import FormikTextInput from "../../../helpers/formikInputs/FormikTextInput"

//SOAR Context
import { UserContext } from "../../../context/userContext"

//Formik
import { Form, Formik } from "formik"
import * as Yup from "yup"
import { useState } from "react"
import { useEffect } from "react"
import { useContext } from "react"
import { LogError } from "../../../helpers/logger"

//Housing components
import { housingApiRemoveUserChargePost } from "../housingApi"

export default function HousingOtherChargeDeleteForm({
  showForm,
  onHideForm,
  chargeEntry,
  onDeleted,
}) {
  const userCtx = useContext(UserContext)

  const [deleteItem, setDeleteItem] = useState({
    id: undefined,
    removalNote: "User removal",
    removalUserId: userCtx.session.user.staff_id,
  })

  useEffect(() => {
    if (!!chargeEntry) {
      setDeleteItem({
        id: chargeEntry?.rent.id,
        removalNote: undefined,
        removalUserId: userCtx.session.user.staff_id,
      })
    } else {
      setDeleteItem({
        id: undefined,
        removalNote: undefined,
        removalUserId: userCtx.session.user.staff_id,
      })
    }
  }, [chargeEntry, userCtx.session.user.staff_id])

  const validationSchema = Yup.object().shape({
    removalNote: Yup.string().required(
      "Please specify a reason for the deletion"
    ),
  })

  const removeCharge = async (values) => {
    try {
      const result = await housingApiRemoveUserChargePost(
        userCtx.tokenHousing,
        values
      )

      if (!!result) {
        onDeleted(result)
      }
    } catch (error) {
      userCtx.setNotificationError("Unable to delete charge")
      LogError("Unable to delete user charge", error)
      return false
    }
  }

  return (
    <Dialog
      header={`Delete confirmation`}
      visible={showForm}
      onHide={() => {
        onHideForm()
      }}
      style={{ width: "400px" }}
    >
      <Formik
        initialValues={deleteItem}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={(values) => {
          return removeCharge(values)
        }}
      >
        {({ isSubmitting, values, dirty, setFieldValue, errors }) => (
          <Form>
            <FormikTextInput
              name={"removalNote"}
              label={"Deletion reason"}
              helpText={"The reason why this charge is being deleted"}
              placeholderText={"Please specify the reason"}
              required={true}
              disabled={isSubmitting}
            />
            <div style={{ float: "right" }}>
              <button
                type="submit"
                className="btn"
                disabled={isSubmitting || !dirty}
              >
                Confirm deletion
              </button>
              <button
                type="button"
                className="btn"
                style={{ marginLeft: "10px" }}
                onClick={() => {
                  onHideForm()
                }}
                disabled={isSubmitting}
              >
                Cancel
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Dialog>
  )
}
